import { Component } from 'react';
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom'
import {compose} from 'redux'
import ConfirmedAbsence from '../../components/Absences/ActionsGroup/ConfirmedAbsence'
import AbsenceToValidate from '../../components/Absences/ActionsGroup/AbsenceToValidate'
import CreateAbsence from '../../components/Absences/ActionsGroup/CreateAbsence'
import ValidatedAbsence from '../../components/Absences/ActionsGroup/ValidatedAbsence'
import CancelledAbsence from '../../components/Absences/ActionsGroup/CancelledAbsence'

class AbsenceActionsForm extends Component {

    render() {
        if(this.props.absences.editionState.creationMode){
            return (<CreateAbsence />)
        } else if(this.props.absences.editionState.updateMode){
            if(this.props.absences.absenceCreationFields.status === 'confirmed'){
                return (<ConfirmedAbsence />)
            } else if(this.props.absences.absenceCreationFields.status === 'validated'){
                return (<ValidatedAbsence />)
            } else if(this.props.absences.absenceCreationFields.status === 'new'){
                return (<CreateAbsence />)
            } else if(this.props.absences.absenceCreationFields.status === 'cancelled'){
                return (<CancelledAbsence />);
            } else {
                return (<div/>)
            }
        } else if(this.props.absences.editionState.validationMode){
            return (<AbsenceToValidate />)
        } else{
            return (<div/>)
        }
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
    };
};

const mapDispatchToProps = () => {
    return {

    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(AbsenceActionsForm);
